// src/pages/AboutPage.jsx
import React from 'react';
import About from '../components/sections/About'; // adjust path if needed

const AboutPage = () => {
  return (
    <div className="pt-24">
      <About />
    </div>
  );
};

export default AboutPage;
